/**
 * Zapis bledu do konsoli przegladarki.
 *
 * Powstalo, bo w kodzie bylo 98 pustych blokow `catch`, ktore polykaly bledy
 * sieciowe bez sladu. Efekt: awaria wygladala identycznie jak brak danych,
 * a programista nie mial czego szukac.
 *
 * Zasada: kazdy blok `catch` w sagach wola te funkcje. Uzytkownik dostaje
 * osobno prosty komunikat "wystapil blad" (patrz komponent StanDanych) -
 * szczegoly techniczne zostaja w konsoli.
 *
 * @param kontekst nazwa sagi albo operacji, np. "payment/GET_ALL_PAYMENTS"
 * @param e        przechwycony wyjatek
 */
export function logError(kontekst: string, e: any): void {
    const status = e && e.response && e.response.status;
    const url = e && e.config && e.config.url;

    console.error(
        `[mygps] Blad w ${kontekst}` +
        (status ? ` — HTTP ${status}` : "") +
        (url ? ` — ${url}` : ""),
        e
    );
}

export default logError;
